import { $post, $download } from '@/api/request'
// 人才管理
export function compTalentsInfo (portType, data = {}) {
  return $post({
    url: `/compTalentsInfo/${portType}`,
    data
  })
}
// 个人加班明细
export function compApplyOvertime (portType, data = {}) {
  return $post({
    url: `/compApplyOvertime/${portType}`,
    data,
  })
}
export function compApplyOvertimeExport (portType, data = {}) {
  return $download({
    url: `/compApplyOvertime/${portType}`,
    responseType: 'blob',
    data,
  })
}
// 请假明细
export function compApplyLeave (portType, data = {}) {
  return $post({
    url: `/compApplyLeave/${portType}`,
    data
  })
}
// 操作日志
export function compOperatorLog (portType, data = {}) {
  return $post({
    url: `/compOperatorLog/${portType}`,
    data
  })
}
// 党员管理
export function partyMemberInfo (portType, data = {}) {
  return $post({
    url: `/partyMemberInfo/${portType}`,
    data
  })
}
// 党建动态
export function partyNewsInfo (portType, data = {}) {
  return $post({
    url: `/partyNewsInfo/${portType}`,
    data
  })
}
// 查询待自己审批的所有申请
export function compTotalApply (portType, data = {}) {
  return $post({
    url: `/compTotalApply/${portType}`,
    data
  })
}
// 通用管理关联下载人
export function compApplyRelPeople (portType, data = {}) {
  return $post({
    url: `/compApplyRelPeople/${portType}`,
    data
  })
}
// 请假明细
export function compIntentionFeedbackInfo (portType, data = {}) {
  return $post({
    url: `/compIntentionFeedbackInfo/${portType}`,
    data
  })
}
// 信息登记审核 
export function compApplyEuFarmerSimpleInfo (portType, data = {}) {
  return $post({
    url: `/compApplyEuFarmerSimpleInfo/${portType}`,
    data
  })
}